// extracted by mini-css-extract-plugin
export default {"invitePage":"ufkBwovjcas4EtoYEpVo","content":"FM17CCfZrMX52bJ3rR4g","logo":"ANSOLqPFgNBnvqYgwSaC","expirationText":"Xoq8xtDfr4aqbhZM0fqH","submitButton":"u60u4tJKzMbAKQZFT4ZM"};